import React from 'react';

const QuemSomos = () => {
  return (
    <section className="py-16 bg-[#DED4C0]" data-testid="quem-somos-section">
      <div className="max-w-4xl mx-auto px-4 text-center">
        <h2 
          id="quem-somos"
          className="text-3xl md:text-4xl font-bold text-[#8B4513] mb-6 scroll-mt-28"
          style={{ fontFamily: 'Cormorant Garamond, serif' }}
        >
          Quem Somos!
        </h2>
        <div className="w-24 h-1 bg-[#DAA520] mx-auto mb-8"></div>
        <p className="text-[#4A3728] text-lg leading-relaxed mb-4">
          Somos uma empresa de cestas de café da manhã e cestas de presente. Nascemos com a missão 
          de surpreender as pessoas que são especiais pra você.
        </p>
        <p className="text-[#4A3728] text-lg leading-relaxed mb-4">
          O Café Colonial Cestas vem construindo sua história desde <strong className="text-[#8B4513]">05/1992</strong>, 
          com desempenho na montagem de Cestas que viraram tendência e referência ao longo dos anos, 
          levando dedicação com qualidade e elegância para satisfazer o cliente que busca o melhor ao presentear.
        </p>
      </div>
    </section>
  );
};

export default QuemSomos;
